var _rect, _rect2, _rect3, _path, _path2, _line, _path3, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataViz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 413,
    height: 388,
    viewBox: "0 0 413 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68.7266,
    y: 61.3572,
    width: 344.273,
    height: 326.058,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 344.273,
    height: 326.058,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5195,
    y: 18.8782,
    width: 358.72,
    height: 320.96,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.24 99.1184C113.519 99.1184 44.8398 167.798 44.8398 252.518H351.64C351.64 167.798 282.96 99.1184 198.24 99.1184Z",
    fill: "#3600CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.074 276.143L254.879 224.198L303.962 243.073L290.297 254.125L305.545 272.922L293.32 282.84L278.056 264.025L263.074 276.143Z",
    fill: "#14D3A6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 199.419,
    y1: 99.1184,
    x2: 199.419,
    y2: 252.518,
    stroke: "white",
    strokeWidth: 2.36
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M307.545 142.434L199.42 252.519",
    stroke: "white",
    strokeWidth: 2.36
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 90.5141,
    y1: 143.124,
    x2: 198.984,
    y2: 251.594,
    stroke: "white",
    strokeWidth: 2.36
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataViz);
export default __webpack_public_path__ + "static/media/DataViz.f8a43eed9aad761244d9ac3ba62e8e84.svg";
export { ForwardRef as ReactComponent };